import { useState, useCallback } from "react";
import { api } from "../api/api"; // Ajuste o caminho relativo da sua API

export function useAdministrativo() {
  // --- Estado: Produtividade ---
  const [dadosProdutividade, setDadosProdutividade] = useState([]);
  const [loadingProdutividade, setLoadingProdutividade] = useState(false);
  const [usuarioExpandidoProd, setUsuarioExpandidoProd] = useState(null);

  // --- Estado: Logins / Logouts ---
  const [logsLogins, setLogsLogins] = useState([]);
  const [loadingLogins, setLoadingLogins] = useState(false);
  const [buscaLogins, setBuscaLogins] = useState("");
  const [filtroActionLogins, setFiltroActionLogins] = useState("todos");
  const [usuarioExpandidoLogins, setUsuarioExpandidoLogins] = useState(null);

  // 1. Carregar Produtividade
  const carregarProdutividade = useCallback(async () => {
    try {
      setLoadingProdutividade(true);
      const res = await api.get("/administrativo/auditoria/produtividade");
      const listaDados = Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data)
        ? res.data
        : [];

      setDadosProdutividade(listaDados);
    } catch (err) {
      console.error("Erro ao carregar relatório de produtividade:", err);
      setDadosProdutividade([]);
    } finally {
      setLoadingProdutividade(false);
    }
  }, []);

  // 2. Carregar Logins / Logouts
  const carregarLogins = useCallback(async () => {
    try {
      setLoadingLogins(true);
      const res = await api.get("/administrativo/auditoria/logins-logouts", {
        params: { search: buscaLogins }
      });
      const listaDados = Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data)
        ? res.data
        : [];

      setLogsLogins(listaDados);
    } catch (err) {
      console.error("Erro ao carregar logs de acesso:", err);
      setLogsLogins([]);
    } finally {
      setLoadingLogins(false);
    }
  }, [buscaLogins]);

  // Alternadores de expansão de usuário
  const toggleExpandirProd = (userId) => {
    if (!userId) return;
    setUsuarioExpandidoProd((prev) => (prev === userId ? null : userId));
  };

  const toggleExpandirLogins = (userId) => {
    if (!userId) return;
    setUsuarioExpandidoLogins((prev) => (prev === userId ? null : userId));
  };

  return {
    // Produtividade
    dadosProdutividade,
    loadingProdutividade,
    usuarioExpandidoProd,
    carregarProdutividade,
    toggleExpandirProd,

    // Logins
    logsLogins,
    loadingLogins,
    buscaLogins,
    setBuscaLogins,
    filtroActionLogins,
    setFiltroActionLogins,
    usuarioExpandidoLogins,
    carregarLogins,
    toggleExpandirLogins
  };
}